import React, { useRef } from 'react';
import styles from './Background.scss';
import BG0 from 'assets/videos/bg-0.mp4';

export function Background() {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleVideoEnd = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  return (
    <div className={styles.backgroundContainer}>
      <div className={styles.videoOverlay} />
      <video className={styles.video} ref={videoRef} autoPlay muted playsInline onEnded={handleVideoEnd}>
        <source src={BG0} type="video/mp4" />
      </video>
    </div>
  );
}
